import { useState, useEffect } from 'react';
import { Arrow } from './Arrow';

export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [onDark, setOnDark] = useState(false);
  
  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 24);
      // detect dark section under nav
      const probe = document.elementFromPoint(window.innerWidth / 2, 40);
      if (!probe) return;
      const dark = probe.closest(".dark");
      setOnDark(!!dark);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  
  return (
    <nav className={`nav ${scrolled ? "scrolled" : ""} ${onDark ? "on-dark" : ""}`}>
      <a href="#top" className="nav-logo">
        <img src="/assets/cases/dee-logo.svg" alt="Dee Logo" width={30} height={30} />
      </a>
      <div className="nav-links">
        <a href="#case-studies">Work</a>
        <a href="#services">Services</a>
        <a href="#process">Process</a>
        <a href="#testimonials">Testimonials</a>
        <a href="#contact">Contact</a>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
        <span className="nav-status">
          <span className="pulse"></span>
          <span>Available</span>
        </span>
        <a href="#contact" className="btn btn-primary" style={{ padding: "10px 18px", fontSize: 13.5 }}>
          Start a project <Arrow size={12} />
        </a>
      </div>
    </nav>
  );
}
